import { Center, Container, Flex, Tag, useToast } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { OrganizationAdministration } from "../../api";
import { showErrorToast } from "../../utils";

function UserInvitation() {
  const [searchParams] = useSearchParams();
  const toast = useToast();

  useEffect(() => {
    const invitationTicketId = searchParams.get("invitation");
    const organizationId = searchParams.get("organization");

    OrganizationAdministration.getOrganizationSubDomain(organizationId).then(
      subDomain => {
        window.location.replace(`https://${process.env.REACT_APP_AUTH_DOMAIN}/authorize?` +
          `audience=${process.env.REACT_APP_AUTH_AUDIENCE}&` +
          `response_type=code&` +
          `client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}&` +
          `redirect_uri=https://${subDomain}.${process.env.REACT_APP_ROUTE}&` +
          `invitation=${invitationTicketId}&` +
          `organization=${organizationId}&` +
          `state=STATE`);
      }).catch(function(error) {
      showErrorToast(toast, error.message);
    });
  }, [searchParams, toast]);

  return <Container h="calc(100vh)">
    <Flex blockSize="full">
      <Center flex="1">
        <Tag size="lg">Redirecting to authorization page ..</Tag>
      </Center>
    </Flex>
  </Container>;
}

export default UserInvitation;
